// Query-keys factory for the profile module.
export const profileKeys = {
  all: ['profile'] as const,
  me: () => [...profileKeys.all, 'me'] as const,
  ownerProfile: () => [...profileKeys.all, 'ownerProfile'] as const,
}
